import { fetchResource } from '@/services/fetchService.js'

class AdService {
  constructor() {
    this.type = ''
  }

  async fetchAds({ locale, keywords = [], zone = '' }) {
    const params = {
      locale,
      keywords: (keywords && keywords.join(',')) || '',
      zone
    }
    const ads = await fetchResource('ads', params)
    return ads
  }
}

export default AdService
export const adService = new AdService()
